import axios from "axios";

/**
 * 랭킹 데이터 가져오기
 * @param {string} period - "daily" | "weekly" | "monthly"
 * @param {function} setRankings - 랭킹 상태 업데이트 함수
 * @param {function} setLoading - 로딩 상태 업데이트 함수
 * @param {function} setError - 에러 상태 업데이트 함수
 */
export const fetchRankingUtil = async (period, setRankings, setLoading, setError) => {
    try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_SPRING_API_URL}/api/ranking?period=${period}`);
        setRankings(response.data);
        setError(null);
    } catch (err) {
        console.error("랭킹 데이터 가져오기 실패:", err);
        setError("랭킹 데이터를 불러오는 데 실패했습니다.");
        setRankings([]);
    } finally {
        setLoading(false);
    }
};
